import { Component, OnInit, Renderer2, Input } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AppNotice } from '../../../models/app-notice.model';
import { AppNoticesService } from '../../../services/app-notices/app-notices.service';
import { ClientReloadService } from '../../../services/client-reload/client-reload.service';
import { CurrentContextService } from '../../../services/current-context/current-context.service';

@Component({
  selector: 'core-persistent-app-notice',
  templateUrl: './persistent-app-notice.component.html',
  styles: [
    `
      a {
        text-decoration: none;
        border-bottom: none;
      }
    `,
  ],
  standalone: false,
})
export class PersistentAppNoticeComponent implements OnInit {
  public appNotice$: Observable<AppNotice>;
  public hideAnnualReminder$ = new BehaviorSubject<boolean>(
    localStorage.getItem('annual_plans_reminder') === 'dismissed'
  );

  public standardAppNotice = true;
  public billingRoute: boolean;

  @Input() public leadCenterNoticesOnly = false;

  constructor(
    public context: CurrentContextService,
    private appNoticesService: AppNoticesService,
    private renderer: Renderer2,
    public clientReload: ClientReloadService,
    private router: Router
  ) {
    this.billingRoute = this.router.url.includes('billing');
  }

  public ngOnInit() {
    this.appNotice$ = this.context.can$('view', 'notices').pipe(
      switchMap((canViewNotices) => {
        if (canViewNotices) {
          return this.appNoticesService.appNotices$.pipe(
            // only show persistent notices
            map((appNotices) => {
              let persistentNotices: AppNotice[] = [];
              if (appNotices) {
                persistentNotices = appNotices.filter(
                  (notice) => notice.persistent
                );
              }
              // Only show notices relevant to lead center if leadCenterNoticesOnly was passed in as true
              if (this.leadCenterNoticesOnly) {
                persistentNotices = persistentNotices.filter(
                  (notice) => notice.category === 'lead center'
                );
              }
              return persistentNotices[0]; // will return undefined if array length 0
            })
          );
        } else {
          // appNotice$ may have notices even it the user doesn't have permission
          return of(null);
        }
      }),
      tap((notice) => this.toggleHasAlertClass(notice))
    );
  }

  public hideAnnualReminder(): void {
    localStorage.setItem('annual_plans_reminder', 'dismissed');
    this.hideAnnualReminder$.next(true);
    this.renderer.removeClass(document.body, 'has-alert-top');
  }

  public dismiss(notice: AppNotice): void {
    this.appNoticesService.dismissAgencyUserAlert(notice.id);
  }

  private toggleHasAlertClass(notice: AppNotice) {
    if (!!notice) {
      this.renderer.addClass(document.body, 'has-alert-top');
    } else {
      this.renderer.removeClass(document.body, 'has-alert-top');
    }
  }
}
